import { Coord } from '../../jscaip/Coord';
import { Ordinal } from '../../jscaip/Ordinal';
import { PlayerOrNoneGameStateWithTable } from '../../jscaip/state/PlayerOrNoneGameStateWithTable';
export class PentagoState extends PlayerOrNoneGameStateWithTable {
    static SIZE = 6;
    static ROTATION_MAP = [
        [new Coord(-1, -1), new Coord(1, -1)],
        [new Coord(0, -1), new Coord(1, 0)],
        [new Coord(1, -1), new Coord(1, 1)],
        [new Coord(1, 0), new Coord(0, 1)],
        [new Coord(1, 1), new Coord(-1, 1)],
        [new Coord(0, 1), new Coord(-1, 0)],
        [new Coord(-1, 1), new Coord(-1, -1)],
        [new Coord(-1, 0), new Coord(0, -1)],
    ];
    static isOnBoard(coord) {
        return coord.isInRange(PentagoState.SIZE, PentagoState.SIZE);
    }
    neutralBlocks;
    constructor(board, turn) {
        super(board, turn);
        this.neutralBlocks = this.getBlocksNeutralities();
    }
    getBlocksNeutralities() {
        const neutralBlocks = [];
        for (let i = 0; i < 4; i++) {
            const blockNeutrality = this.getBlockNeutrality(i);
            if (blockNeutrality) {
                neutralBlocks.push(i);
            }
        }
        return neutralBlocks;
    }
    getBlockNeutrality(blockIndex) {
        const center = PentagoState.getBlockCenter(blockIndex);
        const initialUp = this.getPieceAt(center.getNext(Ordinal.UP, 1));
        const initialDiagonal = this.getPieceAt(center.getNext(Ordinal.UP_LEFT, 1));
        // Testing edges
        if (this.getPieceAt(center.getNext(Ordinal.RIGHT, 1)) !== initialUp ||
            this.getPieceAt(center.getNext(Ordinal.DOWN, 1)) !== initialUp ||
            this.getPieceAt(center.getNext(Ordinal.LEFT, 1)) !== initialUp) {
            return false;
        }
        // Testing corners
        return this.getPieceAt(center.getNext(Ordinal.UP_RIGHT, 1)) === initialDiagonal &&
            this.getPieceAt(center.getNext(Ordinal.DOWN_RIGHT, 1)) === initialDiagonal &&
            this.getPieceAt(center.getNext(Ordinal.DOWN_LEFT, 1)) === initialDiagonal;
    }
    static getBlockCenter(blockIndex) {
        const cx = 1 + (blockIndex % 2 === 0 ? 0 : 3);
        const cy = 1 + (blockIndex < 2 ? 0 : 3);
        return new Coord(cx, cy);
    }
    applyLegalDrop(move) {
        const newBoard = this.getCopiedBoard();
        newBoard[move.coord.y][move.coord.x] = this.getCurrentPlayer();
        return new PentagoState(newBoard, this.turn);
    }
    applyLegalMove(move) {
        const postDropState = this.applyLegalDrop(move);
        const newBoard = postDropState.getCopiedBoard();
        if (move.blockTurned.isPresent()) {
            const blockCenter = PentagoState.getBlockCenter(move.blockTurned.get());
            const blockVector = blockCenter.toVector();
            if (move.turnedClockwise) {
                for (const translation of PentagoState.ROTATION_MAP) {
                    const oldCoord = translation[0].getNext(blockVector);
                    const newCoord = translation[1].getNext(blockVector);
                    const oldValue = postDropState.getPieceAt(oldCoord);
                    newBoard[newCoord.y][newCoord.x] = oldValue;
                }
            }
            else {
                for (const translation of PentagoState.ROTATION_MAP) {
                    const oldCoord = translation[1].getNext(blockVector);
                    const newCoord = translation[0].getNext(blockVector);
                    const oldValue = postDropState.getPieceAt(oldCoord);
                    newBoard[newCoord.y][newCoord.x] = oldValue;
                }
            }
        }
        return new PentagoState(newBoard, this.turn + 1);
    }
    blockIsNeutral(blockIndex) {
        return this.neutralBlocks.includes(blockIndex);
    }
}
